export const ONFIDO_CONTAINER_NAME = "onfido-container";
export const DEFAULT_LANGUAGE = "it";
export const DEFAULT_SMS_COUNTRY_CODE = "IT";

export const ONFIDO_KEYS = {
  VIDEO_CAPTCHA: "VIDEO_CAPTCHA",
  OCR_DOCUMENTO: "OCR_DOCUMENTO",
  OCR_DOCUMENTO_2: "OCR_DOCUMENTO_2",
  DOCUMENT: "document",
  FACE: "face",
  VIDEO: "video",
  MOTION: "motion",
  DOCUMENT_FRONT: "document_front",
  DOCUMENT_BACK: "document_back",
  FRONT: "front",
  BACK: "back",
} as const;

export const ERROR_CODES = {
  MISSING_TOKEN: 100,
  START_GENERIC_ERROR: 101,
  NEXT_PHASE_GENERIC_ERROR: 102,
  PREV_PHASE_GENERIC_ERROR: 103,
  SAVE_ERROR: 104,
  RESUME_MISSING_TOKEN: 200,
  RESUME_START_GENERIC_ERROR: 201,
  RESUME_NEXT_PHASE_GENERIC_ERROR: 202,
  RESUME_SAVE_ERROR: 203,
};
